/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  filterMapIterable.ts
 */

export type IteratorFilterCallback<T> = (
  value: T,
  i: number,
  iterable: IterableIterator<T>
) => boolean

export type IteratorMapCallback<T, TReturn = T> = (
  value: T
) => TReturn | undefined

export const filterMapIterable = function* <T, TReturn = T>(
  iterable: IterableIterator<T>,
  filterCallback: IteratorFilterCallback<T>,
  mapCallback?: IteratorMapCallback<T, TReturn>
): IterableIterator<TReturn> {
  let i = -1
  for (const value of iterable) {
    if (filterCallback(value, ++i, iterable)) {
      // TODO: use an overload to fix the type casting below
      // https://github.com/zumper/web-shared-packages/pull/109#discussion_r467187467
      const result = mapCallback
        ? mapCallback(value)
        : (value as unknown as TReturn)
      /* istanbul ignore next */
      if (result !== undefined) {
        yield result
      }
    }
  }
}
